import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaRegEdit } from 'react-icons/fa';
import DeviceAccordion from './DeviceAccordion';
import ActionsAccordion from './ActionsAccordion';
import PatchesAccordion from './PatchesAccordion';
import Sandbox from './Sandbox';

const ApproveForm = ({ heading }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div className="bg-zinc-900 text-white p-4 rounded-md border border-white/20">
        <div
          className="flex justify-between items-center cursor-pointer p-3 bg-[#2a2a2a] rounded-md"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <span>{heading}</span>
          <div className="flex items-center space-x-4" onClick={() => setIsExpanded(!isExpanded)}>
            <FaRegEdit className="cursor-pointer hover:text-gray-300" />
            <div onClick={() => setIsExpanded(!isExpanded)}>{isExpanded ? <FaChevronUp /> : <FaChevronDown />}</div>
          </div>
        </div>

        {/* Optional expandable content */}
        {isExpanded && heading === 'Sandbox' && (
          <div className="mt-2 bg-zinc-900 border border-gray-600 rounded-md p-3">
            <Sandbox heading="SANDBOX" isExpanded={isExpanded} toggleExpanded={() => setIsExpanded((prev) => !prev)} />
          </div>
        )}
        {isExpanded && heading === 'Selected Devices' && (
          <div className="mt-2 bg-zinc-900 border border-gray-600 rounded-md p-3">
            <DeviceAccordion heading="SELECTED DEVICES" isExpanded={isExpanded} toggleExpanded={() => setIsExpanded((prev) => !prev)} />
          </div>
        )}
        {isExpanded && heading === 'Actions' && (
          <div className="mt-2 bg-zinc-900 border border-gray-600 rounded-md p-3">
            <ActionsAccordion />
          </div>
        )}
        {isExpanded && heading === 'Patches Available' && (
          <div className="mt-2 bg-zinc-900 border border-gray-600 rounded-md p-3">
            <PatchesAccordion />
          </div>
        )}
      </div>
    </>
  );
};

export default ApproveForm;
